"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageType = exports.NodeFactory = exports.Version = exports.Node = exports.nodeType = void 0;
const crypto_1 = require("@akord/crypto");
const not_found_1 = require("../errors/not-found");
var nodeType;
(function (nodeType) {
    nodeType["STACK"] = "Stack";
    nodeType["FOLDER"] = "Folder";
    nodeType["MEMO"] = "Memo";
    nodeType["NOTE"] = "Note";
    nodeType["NFT"] = "NFT";
    nodeType["COLLECTION"] = "Collection";
})(nodeType = exports.nodeType || (exports.nodeType = {}));
class Node extends crypto_1.Encryptable {
    constructor(nodeLikeProto, keys, publicKey) {
        super(keys ? keys : nodeLikeProto.__keys__, publicKey ? publicKey : nodeLikeProto.__publicKey__);
        this.id = nodeLikeProto.id;
        this.createdAt = nodeLikeProto.createdAt;
        this.updatedAt = nodeLikeProto.updatedAt;
        this.status = nodeLikeProto.status;
        this.vaultId = nodeLikeProto.vaultId;
        this.owner = nodeLikeProto.owner;
        this.data = nodeLikeProto.data;
        this.parentId = nodeLikeProto.parentId;
        this.tags = nodeLikeProto.tags;
        this.__public__ = nodeLikeProto.__public__;
        this.__cloud__ = nodeLikeProto.__cloud__;
    }
    getVersion(index) {
        if (index >= 0) {
            if (this.versions && this.versions[index]) {
                return this.versions[index];
            }
            else {
                throw new not_found_1.NotFound("A version with given index: " + index + " does not exist for node: " + this.id);
            }
        }
        else {
            return this.versions && this.versions.length > 0 && this.versions[this.versions.length - 1] || undefined;
        }
    }
}
exports.Node = Node;
class Version extends crypto_1.Encryptable {
    constructor(versionProto, keys, publicKey) {
        super(keys, publicKey);
        this.owner = versionProto.owner;
        this.createdAt = versionProto.createdAt;
    }
}
exports.Version = Version;
class NodeFactory {
    static instance(nodeLike, data, keys) {
        return new nodeLike(data, keys);
    }
}
exports.NodeFactory = NodeFactory;
var StorageType;
(function (StorageType) {
    StorageType["S3"] = "s3:";
    StorageType["ARWEAVE"] = "arweave:";
})(StorageType = exports.StorageType || (exports.StorageType = {}));
